import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);

// Set initial states
const state = {
  alerts: []
};

const mutations = {
  // A mutation receives the current state as the first argument
  // You can make any modifications you want inside this function
  ALERT (state, title, message, type, autohide) {

    if (autohide == null) {
      autohide = 5000;
    }

    var item = {
      title: title,
      message: message,
      type: type,
      autohide: autohide,
      show: true
    };

    state.alerts.push(item);
    var pos = state.alerts.length - 1;

    // Hide
    setTimeout(function () {state.alerts[pos].show = false;}, autohide);
  }
};

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js